import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { postRequest } from 'src/utils/request';
import messages from 'src/pages/SetupPage/messages';
import { RequestSimplifiedData } from 'src/types/requestData';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';

export interface tutorialParamsType {
  code: string;
  titleEn: string;
  titleDe: string;
  typeCode: string;
  cohortCode: string;
  descriptionEn: string | null;
  descriptionDe: string | null;
}

const createTutorial = async (tutorial: tutorialParamsType) => {
  const { data } = await postRequest<RequestSimplifiedData>(
    API.POST.createTutorial,
    tutorialParamsBuilder(tutorial),
  );

  return data;
};

export const useCreateTutorial = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: createTutorial,
    onSuccess: () => {
      handleSuccess(formatMessage(messages.tutorialSaved), 1000);
      client.invalidateQueries({ queryKey: [QUERY_KEYS.TUTORIALS] });
    },
    onError: handleError,
  });
};

export const tutorialParamsBuilder = (tutorial: tutorialParamsType) => {
  return {
    tutorial: {
      code: tutorial.code,
      title_en: tutorial.titleEn,
      title_de: tutorial.titleDe,
      description_en: tutorial.descriptionEn,
      description_de: tutorial.descriptionDe,
      cohort: tutorial.cohortCode,
      type: tutorial.typeCode,
      kind: tutorial.typeCode,
    },
  };
};
